module.exports = new __parcel__URL__("ill_compass.260520ef.svg").toString();